/**
 * Home "capture-first" empty-state decision (pure, testable).
 *
 * A brand-new zero-input workspace (typically a fresh Personal workspace)
 * must NOT be pushed into weekly-draft machinery ("0 of 5 approved",
 * "Draft now", "Rest day" as the hero). Instead it shows a capture-first
 * empty state. Weekly progress appears only once the week has meaningful
 * input or approved-receipt history.
 *
 * Rules:
 *   • capture-first iff the viewed week has NO signals/captures on any day,
 *     AND no daily receipts, AND no approved workdays, AND no weekly receipt.
 *   • "Rest day" being today is irrelevant to this decision — a zero-input
 *     week is capture-first whether today is a working day or a rest day.
 */
export type HomeWeekActivity = {
  /** Per-day signal/capture counts for the viewed week. */
  daySignalCounts: number[];
  /** Number of daily receipts that exist for the viewed week. */
  dailyReceiptCount: number;
  /** Working days in the week that already have an APPROVED receipt. */
  approvedWorkdays: number;
  /** Whether a weekly receipt (draft or approved) exists for the week. */
  hasWeeklyReceipt: boolean;
};

export function showCaptureFirst(a: HomeWeekActivity): boolean {
  const anySignal = a.daySignalCounts.some(n => n > 0);
  return (
    !anySignal &&
    a.dailyReceiptCount === 0 &&
    a.approvedWorkdays === 0 &&
    !a.hasWeeklyReceipt
  );
}
